import script from "./EstimateReceivedSummaryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateReceivedSummaryDetails.vue?vue&type=script&setup=true&lang=js"

import "./EstimateReceivedSummaryDetails.vue?vue&type=style&index=0&id=0c4d7cfe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4d7cfe"]])

export default __exports__